import { CantPayOnlineReason } from "@core/schema/CantPayOnlineReason.js";
import type { OrderCreateInput } from "@core/schema/Order.js";
import { maxOnlinePrice } from "@core/schema/maxOnlinePrice.js";
import { getPriceOfOrder } from "@core/schema/utils/getPriceOfOrder.js";

export function getCantPayOnlineReasons(order: Pick<OrderCreateInput, "products">): CantPayOnlineReason[] {
	const cartPrice = getPriceOfOrder(order);
	const reasons: CantPayOnlineReason[] = [];

	if (cartPrice.totalPrice.withTax > maxOnlinePrice) {
		reasons.push(CantPayOnlineReason.PriceTooHigh);
	}

	return reasons;
}
